import {
    RETREIVE_PRODUCTS_ACTION,
    RETREIVE_PRODUCTS_MUTATION,
    SET_SHOP_LOADING_TO_TRUE,
    SET_SHOP_LOADING_TO_FALSE,
    RETREIVE_CATEGORIES_ACTION,
    RETREIVE_CATEGORIES_MUTATION,
    SET_FILTER_CATEGORY_ACTION,
    SET_FILTER_CATEGORY_MUTATION,
    SET_FILTER_TYPE_ACTION,
    SET_FILTER_TYPE_MUTATION,
    RETREIVE_FEATURES_FILTER_ACTION,
    RETREIVE_FEATURES_FILTER_MUTATION,
    GET_FILTER,
    REMOVE_FILTER_ACTION,
    SET_FEATURES_FILTER_SELECTED,
    SET_TYPES_FILTER_SELECTED,
    CLEAR_FILTERS_ACTION
} from "./types";
import axios from "axios";
const uri = "/api/products";
const notifyKO = console.error;
const notifyOK = console.log;
import {replaceString} from '@/js/utils';

const shopActions = {
    [RETREIVE_PRODUCTS_ACTION]({ commit }) {
        commit(SET_SHOP_LOADING_TO_TRUE);

        axios
            .get(uri + "/all")
            .then(res => {
                commit(RETREIVE_PRODUCTS_MUTATION, res.data);
                commit(SET_SHOP_LOADING_TO_FALSE);
            })
            .catch(err => {
                notifyKO("No ha ido bien");
            });
    },
    [RETREIVE_CATEGORIES_ACTION]({ commit }) {
        axios
            .get(uri + "/categories")
            .then(res => {
                commit(RETREIVE_CATEGORIES_MUTATION, res.data);
            })
            .catch(err => {
                notifyKO("RETRIEVE_CATEGORIES ERROR", err);
            });
    },
    [SET_FILTER_CATEGORY_ACTION]({ state,commit, getters, dispatch }, category) {
        const oldUrl = window.location.href;
        const oldCategory = window.location.href.split('/').pop();
        let nextUrl;
        switch (category.case) {
            case 'all':
                nextUrl = replaceString(oldCategory, 'all', oldUrl);
                break;
            case 'discount':
                nextUrl = replaceString(oldCategory, 'offers', oldUrl);
                break;
            case 'newArrival':
                nextUrl = replaceString(oldCategory, 'new-arrivals', oldUrl);
                break;
            default:
                nextUrl = replaceString(oldCategory, category.slug && category.slug.en, oldUrl);
                break;
        }
        window.history.replaceState('', '', nextUrl);
        if(category.id && state.filter.id == category.id) return;
        commit(SET_SHOP_LOADING_TO_TRUE);
        commit(SET_FILTER_CATEGORY_MUTATION, category);
        setTimeout(() => {
            commit(SET_SHOP_LOADING_TO_FALSE);
        }, 600);
    },

    [SET_FILTER_TYPE_ACTION]({ state, commit }, type) {
        commit(SET_FILTER_TYPE_MUTATION, type);
    },
    [RETREIVE_FEATURES_FILTER_ACTION]({state, commit}){
        axios
            .get(`/api/filter`)
            .then(({data}) => {
                commit(RETREIVE_FEATURES_FILTER_MUTATION, data.data);
            })
            .catch(err => {
                notifyKO("RETRIEVE_FILTER ERROR", err);
            });
    },
    [REMOVE_FILTER_ACTION]({state, commit}, filter){
        let filtersSelected = state.featuresFilterSelected;
        filtersSelected = filtersSelected.filter(f => f.name != filter.name);
        if(filter.cat === 'type') commit(SET_TYPES_FILTER_SELECTED, null);
        commit(SET_FEATURES_FILTER_SELECTED, filtersSelected);
    },
    [CLEAR_FILTERS_ACTION]({state, commit}) {
        commit(SET_FEATURES_FILTER_SELECTED, []);
        commit(SET_TYPES_FILTER_SELECTED, null);
    }
};

export default shopActions;
